<template>
  <div class="fill-height">
    <v-app-bar app color="indigo" dark>
      <v-avatar tile size="42" class="mx-2 hidden-sm-and-down">
        <img :src="require('@/assets/kuzstu-logo2.png')" alt="logo"/>
      </v-avatar>
      <v-toolbar-title class="hidden-sm-and-down">
        <span>АБИТУРИЕНТ КУЗГТУ</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <user-menu></user-menu>
    </v-app-bar>
    <v-main class="fill-height">
      <router-view></router-view>
    </v-main>
    <Footer app></Footer>
  </div>
</template>
<script>
  import Footer from "./Footer";
  import {mapGetters} from "vuex";
  import UserMenu from "./UserMenu";
  import {mdiPlus} from '@mdi/js'

  export default {
    name: "Index",
    components: {
      UserMenu,
      Footer
    },
    data() {
      return {
        mdiPlus,
      }
    },
    computed: {
      ...mapGetters("auth", ["is_authenticated"])
    },
  };
</script>
<style scoped>

</style>
